// extracted by mini-css-extract-plugin
export default {"scroll-to-top__container":"styles_scroll-to-top__container__UQunB"};